import * as Yup from "yup";

export const creditCreate = () =>
  Yup.object().shape({
    customerName: Yup.string()
      .max(255)
      .required("Vui lòng nhập tên khách hàng"),
    loanAmount: Yup.number()
      .min(1)
      .required("Vui lòng nhập số tiền"),
    interestForm: Yup.number().required("Vui lòng chọn hình thức lãi"),
    numberPeriod: Yup.number().required("Vui lòng nhập số ngày vay"),
    interestTerm: Yup.number().required("Vui lòng nhập kỳ lãi"),
    interestRate: Yup.number().required("Vui lòng nhập lãi"),
    loanDate: Yup.date().required("Vui lòng nhập ngày")
  });

export const creditActivity = () =>
  Yup.object().shape({
    partnerName: Yup.string()
      .max(255)
      .required("Vui lòng nhập người nhận"),
    amount: Yup.number()
      .min(1)
      .required("Vui lòng nhập số tiền"),
    voucherType: Yup.number().required("Vui lòng chọn loại phiếu"),
    reason: Yup.string().required("Vui lòng nhập lý do")
  });

export const creditEdit = () =>
  Yup.object().shape({
    customerName: Yup.string()
      .max(255)
      .required("Vui lòng nhập tên khách hàng")
  });
export const creditRotate = () =>
  Yup.object().shape({
    loanAmount: Yup.number()
      .min(1)
      .required("Vui lòng nhập số tiền"),
    receiveAmount: Yup.number()
      .min(1)
      .required("Vui lòng nhập số tiền"),
    numberPeriod: Yup.number()
      .min(1)
      .required("Vui lòng nhập số ngày"),
    duration: Yup.number()
      .min(1)
      .required("Vui lòng nhập số ngày"),
    date: Yup.date().required("Vui lòng nhập ngày")
  });
export const creditCapital = () =>
  Yup.object().shape({
    amount: Yup.number()
      .min(1)
      .required("Vui lòng nhập số tiền")
  });
export const extend = () =>
  Yup.object().shape({
    numberPeriod: Yup.number()
      .min(1)
      .required("Vui lòng nhập số ngày")
  });
